import { reactive } from 'vue'

const ua = navigator.userAgent || ''
const isMobileFn = () => {
  return /(iPhone|iPad|iPod|iOS|Android)/i.test(ua)
}
export const isWechat = /micromessenger\/([\d.]+)/i.test(ua)
export const isAndroid = /android/i.test(ua)
export const isIos = /iphone|ipad|ipod/i.test(ua)
export const isInGame = window.mnw && window.mnw.getUserAuth

const deviceState = reactive({
  isMobile: isMobileFn(),
  isWechat,
  isAndroid,
  isIos,
  isInGame
})

function initDevice() {
  const resizeHandler = Utils.throttle(() => {
    const isMobile = isMobileFn()
    deviceState.isMobile = isMobile
  }, 300)

  window.addEventListener('resize', resizeHandler)
}

initDevice()

export default deviceState
